import { createContext } from "react";

export type TabsContextType = {
  activeValue: string;
  setActiveValue: (value: string) => void;
  idPrefix: string;
};

export const TabsContext = createContext<TabsContextType | null>(null);
